
import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { FileUploadService } from './file-upload.service';
import * as XLSX from 'xlsx';
import { CommonModule } from '@angular/common';
import { snackbarService } from '@one/web-components';

@Component({
  selector: 'dl-file-upload',
  standalone: true,
  imports:[OneWebComponentsAngularModule,CommonModule],
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss'
})
export class FileUploadComponent {

  public title = 'XlsRead';
  public file: File;
  public arrayBuffer: any;
  public filelist: any;
  public fileSizeFlag = true;
  @ViewChild('fileDropRef', { static: false }) public fileDropEl: ElementRef;
  public files: any[] = [];
  public dataTosend: any;
  public csvRecords: any[] = [];
  public isCheckOneFileFlag = true;
  @Output() public dataToSendImportComp = new EventEmitter<object>();
  public constructor(private fileuploadService: FileUploadService) {}

  public ngOnInit(): void {
  }
  /**
   * on file drop handler
   */
  public onFileDroppedandSelect(event: any): void {
    
    
    if (this.isCheckOneFileFlag) {
      const files = event?.target?.files;
      if (files && files.length > 0) {
        this.addfile(files[0]);  // Pass the first File object
      }
    }
  }
  

  /**
   * Delete file from files list
   * @param index (File index)
   */
 
  public showFileInput = true;

  public deleteFile(index: number): void {
    this.files.splice(index, 1);
  
    this.dataTosend = {
      fileDetails: {},
      columnDetails: [],
      action: 'delete'
    };
  
    this.isCheckOneFileFlag = true;
    this.dataToSendImportComp.emit(this.dataTosend);
    this.fileuploadService.sendFileUploadedData(this.dataTosend);
  
    // Reset input by toggling showFileInput off and back on
    this.showFileInput = false;
    setTimeout(() => {
      this.showFileInput = true;
    }, 0);
  }
  
  // public deleteFile(index: number): void {
  //   this.files.splice(index, 1);
  //   this.dataTosend = {
  //     fileDetails: {},
  //     columnDetails: [],
  //     action: 'delete'
  //   };
  
  //   if (this.fileDropEl && this.fileDropEl.nativeElement) {
  //     this.fileDropEl.nativeElement.value = '';
  //     this.fileDropEl.nativeElement.disabled = false;
  //   }
  
  //   this.isCheckOneFileFlag = true;
  //   this.dataToSendImportComp.emit(this.dataTosend);
  //   this.fileuploadService.sendFileUploadedData(this.dataTosend);
  // }
  

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  public prepareFilesList(files: Array<any>): void {
    this.files.push(files);
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  public formatBytes(bytes: number, decimals: number = 2, fileName: any = 'Sample'): string {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const sizeInNum = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
    const typeofFile = sizes[i];

    if (sizeInNum <= 0 || sizeInNum >= 15 && typeofFile === 'MB') {
      this.snackBarMessage('alarm',`The file ${fileName.name} could not be uploaded. The maximum file size is 15 MB and should not be empty.`);
      this.fileSizeFlag = false;
    } else {
      this.fileSizeFlag = true;
    }

    return sizeInNum + ' ' + typeofFile;
  }

  public isValidCSVOrEXLFile(file: any): boolean {
    if (file?.name?.endsWith('.csv') || file?.name?.endsWith('.xlsx') || file?.name?.endsWith('.xls')) {
      return true;
    } else {
      this.snackBarMessage('alarm',`The file ${file.name} could not be uploaded. Only the file formats .xlsx and .csv are allowed.`);
      return false;
    }
  }
  

  public addfile(event: any): void {
    this.formatBytes(event.size, undefined, event);
    if (this.isValidCSVOrEXLFile(event) && this.fileSizeFlag && this.isCheckOneFileFlag) {
  
     
      let jsData;

      this.prepareFilesList(event);
      this.file = event;
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(this.file);
      fileReader.onload = e => {
        this.arrayBuffer = fileReader.result;
        const data = new Uint8Array(this.arrayBuffer);
        const arr = new Array();
        for (let i = 0; i !== data.length; ++i) arr[i] = String.fromCharCode(data[i]);
        const bstr = arr.join('');
        const workbook = XLSX.read(bstr, { type: 'binary' });
        const FIRST_SHEET_NAME = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[FIRST_SHEET_NAME];
        jsData = XLSX.utils.sheet_to_json(worksheet, { raw: false });
        this.fileuploadService.getSheetToJSONData(jsData);

        // Use header:1 to read the actual row-1 cells as the column list.
        // Object.keys(arraylist[0]) would silently drop columns whose first data
        // cell is empty — header:1 always returns every column name from row 1.
        const rawRows = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
        const columnDetails = (rawRows[0] as string[]).filter(h => h !== null && h !== undefined && String(h).trim() !== '');

        this.filelist = [];
        this.dataTosend = {
          fileDetails: event,
          columnDetails,
          action: 'Insert'
        };
        if (this.fileDropEl && this.fileDropEl.nativeElement) {
         this.fileDropEl.nativeElement.disabled = true;
        }
        
        
        this.isCheckOneFileFlag = false;
        this.dataToSendImportComp.emit(this.dataTosend);
       
        
        this.fileuploadService.sendFileUploadedData(this.dataTosend);
      };
    } else {
      event = '';
      this.fileSizeFlag = true;
    }
  }

   snackBarMessage(status:any,message:string){
      snackbarService.show({
        message: message, 
        snackbarProps: {
          status: status,
          direction: 'horizontal',
          showClose: true,
          elevated: false,
          duration: 5000,
          verticalPlacement: 'top',
          horizontalPlacement: 'right',
        }
      });
    }
}

